import Question from "./question.js"
import EssayQuestionComponent from "../components/questions/essay-question.jsx"
class EssayQuestion extends Question {
  component(mode) {
   return EssayQuestionComponent;
  }
}

export default EssayQuestion;